<template>
  <div class="orderMain">
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
      <el-tab-pane label="门店管理" name="first"> </el-tab-pane>
      <el-tab-pane label="账号管理" name="second">
        <div></div>
      </el-tab-pane>
      <!--      <el-tab-pane label="角色权限" name="three">-->
      <!--        <div>-->

      <!--        </div>-->
      <!--      </el-tab-pane>-->
      <el-tab-pane label="会员等级" name="four">
        <div>
          <div class="title_div">
            <span class="title-span">会员卡名称:</span>
            <el-input
              clearable
              size="small"
              class="title-select"
              @input="cardNameChange"
              v-model="hykParams.cardName"
            ></el-input>
          </div>
          <div>
            <!-- <el-button
              class="creat-button"
              type="primary"
              size="small"
              @click="creatHykDialogVisible = true"
              >新建会员卡
            </el-button> -->
            <!-- <el-button
              class="creat-button"
              type="primary"
              size="small"
              @click="hyChange"
              >会员规则
            </el-button> -->
            <!-- <el-button
              class="creat-button"
              type="primary"
              size="small"
              @click="jfChange"
              >积分规则
            </el-button> -->
            <el-button
              class="creat-button"
              type="primary"
              size="small"
              @click="ruleButton"
              >规则设置
            </el-button>
            <el-button
              class="creat-button"
              type="primary"
              size="small"
              @click="honourManage"
              >会员荣誉
            </el-button>
            <el-switch
              v-model="configValue"
              active-text="会员箭票转赠开启"
              inactive-text="会员箭票转赠关闭"
              active-value="1"
              inactive-value="2"
              @change="switchChange"
            >
            </el-switch>
          </div>
          <div class="mm-tb">
            <el-table :data="hykList" style="width: 100%">
              <el-table-column
                type="index"
                label="序号"
                align="center"
                width="80"
              >
              </el-table-column>
              <el-table-column
                prop="cardName"
                label="会员卡名称"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="level" label="会员卡等级" align="center">
              </el-table-column>
              <el-table-column prop="phone" label="会员权益" align="center">
                <template slot-scope="scope">
                  <div
                    v-for="(item, index) in scope.row.equitiesList"
                    :key="index"
                  >
                    <span>{{ item.pointStart }}积分{{ item.price }}元/组</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="arrowVolume"
                label="赠送箭劵"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="arrowVolumeDays"
                label="赠送箭劵有效期(天)"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="electronicCard"
                label="电子卡"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="electronicCardDays"
                label="电子卡有效期(天)"
                align="center"
                width="150"
              ></el-table-column>
              <el-table-column
                prop="followPrice"
                label="随行价格"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="upgradePrice"
                label="会员价格"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="storedValue"
                label="赠送储值"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="createDate"
                label="创建日期"
                align="center"
              >
                <template slot-scope="scope">{{
                  scope.row.createDate.substring(0, 10)
                }}</template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="medium"
                    @click="hykEdit(scope.row.id)"
                    >编辑</el-button
                  >
                  <!--                  <el-button type="text" size="medium" @click="changePwd(scope.row.userId)">修改密码</el-button>-->
                  <!--                  <el-button type="text" size="medium" @click="deletZh(scope.row.userId)">注销</el-button>-->
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div>
            <el-pagination
              class="mm-page"
              @size-change="hykSizeChange"
              @current-change="hykCurrentChange"
              :current-page="hykResult.current"
              :page-size="hykResult.size"
              layout="total,prev, pager, next, sizes"
              :total="hykResult.total"
              :page-sizes="[10, 20, 30, 40, 50]"
            >
            </el-pagination>
          </div>
          <el-dialog
            title="新建会员卡"
            :visible.sync="creatHykDialogVisible"
            width="860px"
            :close-on-click-modal="false"
          >
            <div class="dialog-div">
              <span class="title-span">等级名称:</span>
              <el-input
                size="small"
                class="title-select"
                v-model="creatCard.cardName"
              ></el-input>
            </div>
            <div class="dialog-div">
              <span class="title-span">会员等级:</span>
              <el-select
                clearable
                v-model="creatCard.level"
                size="small"
                class="title-select"
              >
                <el-option
                  v-for="item in this.LevelSelectList"
                  :value="item.key"
                  :key="'creat' + item.key"
                  :label="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="dialog-div">
              <span class="title-span">办理金额:</span>
              <el-input
                size="small"
                class="title-select"
                v-model="creatCard.upgradePrice"
                onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
              ></el-input>
              <span class="title-span">元</span>
            </div>
            <div class="dialog-div">
              <span class="title-span">积分权益:</span>
              <el-button
                type="primary"
                class="title-select"
                size="small"
                @click="addCreatLabel"
                >添 加</el-button
              >
            </div>
            <div class="dialog-div">
              <div
                v-for="(item, index) in creatCard.equitiesList"
                style="
                  padding-right: 25px;
                  position: relative;
                  margin-top: 20px;
                "
                :key="index"
              >
                <el-input
                  v-model="item.pointStart"
                  placeholder="请输入积分"
                  size="small"
                  style="width: 100px"
                  onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                  onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                  :key="index"
                />
                <span style="margin: 0 10px">至</span>
                <el-input
                  v-model="item.pointEnd"
                  placeholder="请输入积分"
                  size="small"
                  style="width: 100px"
                  onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                  onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                  :key="index"
                />
                <span style="margin: 0 10px">,</span>
                <el-input
                  v-model="item.price"
                  placeholder="请输入金额"
                  size="small"
                  style="width: 100px"
                  onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                  onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                  :key="index"
                />
                <span style="margin: 0 10px">元/组</span>
                <Icon
                  type="md-remove-circle"
                  size="20"
                  class="del_icon_style"
                  color="#ed4014"
                  v-if="index !== 0"
                  @click="delCreatLabel(index)"
                />
              </div>
            </div>
            <div class="dialog-div">
              <span class="title-span">赠送箭票:</span>
              <el-input
                size="small"
                class="title-select"
                v-model="creatCard.arrowVolume"
                onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
              ></el-input>
              <span class="title-span">张</span>
            </div>
            <div class="dialog-div">
              <span class="title-span">电&nbsp;&nbsp;子&nbsp;&nbsp;卡:</span>
              <el-input
                size="small"
                class="title-select"
                v-model="creatCard.electronicCard"
                onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
              ></el-input>
              <span class="title-span">张</span>
              <span class="title-span"
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;有&nbsp;&nbsp;效&nbsp;&nbsp;期:</span
              >
              <el-input
                size="small"
                class="title-select"
                v-model="creatCard.electronicCardDays"
                onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
              ></el-input>
              <span class="title-span">天</span>
            </div>
            <div class="dialog-div">
              <span class="title-span"
                >储&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;值:</span
              >
              <el-input
                size="small"
                class="title-select"
                v-model="creatCard.storedValue"
                onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
              ></el-input>
              <span class="title-span">元</span>
            </div>
            <div class="dialog-div">
              <span class="title-span">随行价格:</span>
              <el-input
                size="small"
                class="title-select"
                v-model="creatCard.followPrice"
                onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
              ></el-input>
              <span class="title-span">元/组</span>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="creatHykDialogVisible = false"
                >取 消</el-button
              >
              <el-button type="primary" @click="createHykCommit"
                >确 定</el-button
              >
            </span>
          </el-dialog>
          <el-dialog
            title="编辑会员卡"
            :visible.sync="editHykDialogVisible"
            width="860px"
            :close-on-click-modal="false"
          >
            <div class="dialog-div">
              <span class="title-span">等级名称:</span>
              <el-input
                size="small"
                class="title-select"
                v-model="editCard.cardName"
              ></el-input>
            </div>
            <div class="dialog-div">
              <span class="title-span">会员等级:</span>
              <el-select
                clearable
                v-model="editCard.level"
                size="small"
                class="title-select"
                :disabled="true"
              >
                <el-option
                  v-for="item in this.LevelSelectList"
                  :value="item.key"
                  :key="item.key"
                  :label="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="dialog-div">
              <span class="title-span">办理金额:</span>
              <el-input
                size="small"
                class="title-select"
                v-model="editCard.upgradePrice"
                onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
              ></el-input>
              <span class="title-span">元</span>
            </div>
            <div class="dialog-div">
              <span class="title-span">积分权益:</span>
              <el-button
                type="primary"
                class="title-select"
                size="small"
                @click="addEditLabel"
                >添 加</el-button
              >
            </div>
            <div class="dialog-div">
              <div
                v-for="(item, index) in editCard.equitiesList"
                style="
                  padding-right: 25px;
                  position: relative;
                  margin-top: 20px;
                "
                :key="index"
              >
                <el-input
                  v-model="item.pointStart"
                  placeholder="请输入积分"
                  size="small"
                  onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                  onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                  style="width: 100px"
                  :key="index"
                />
                <span style="margin: 0 10px">至</span>
                <el-input
                  v-model="item.pointEnd"
                  placeholder="请输入积分"
                  size="small"
                  onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                  onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                  style="width: 100px"
                  :key="index"
                />
                <span style="margin: 0 10px">,</span>
                <el-input
                  v-model="item.price"
                  placeholder="请输入金额"
                  size="small"
                  onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                  onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                  style="width: 100px"
                  :key="index"
                />
                <span style="margin: 0 10px">元/组</span>
                <Icon
                  type="md-remove-circle"
                  size="20"
                  class="del_icon_style"
                  color="#ed4014"
                  v-if="index !== 0"
                  @click="delEditLabel(index)"
                />
              </div>
            </div>
            <div class="dialog-div">
              <span class="title-span">赠送箭票:</span>
              <el-input
                size="small"
                class="title-select"
                v-model="editCard.arrowVolume"
                onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
              ></el-input>
              <span class="title-span">张</span>
              <span class="title-span"
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;有&nbsp;&nbsp;效&nbsp;&nbsp;期:</span
              >
              <el-input
                size="small"
                class="title-select"
                v-model="editCard.arrowVolumeDays"
                onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
              ></el-input>
              <span class="title-span">天</span>
            </div>
            <div class="dialog-div">
              <span class="title-span">电&nbsp;&nbsp;子&nbsp;&nbsp;卡:</span>
              <el-input
                size="small"
                class="title-select"
                v-model="editCard.electronicCard"
                onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
              ></el-input>
              <span class="title-span">张</span>
              <span class="title-span"
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;有&nbsp;&nbsp;效&nbsp;&nbsp;期:</span
              >
              <el-input
                size="small"
                class="title-select"
                v-model="editCard.electronicCardDays"
                onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
              ></el-input>
              <span class="title-span">天</span>
            </div>
            <div class="dialog-div">
              <span class="title-span"
                >储&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;值:</span
              >
              <el-input
                size="small"
                class="title-select"
                v-model="editCard.storedValue"
                onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
              ></el-input>
              <span class="title-span">元</span>
            </div>
            <div class="dialog-div">
              <span class="title-span">随行价格:</span>
              <el-input
                size="small"
                class="title-select"
                v-model="editCard.followPrice"
                onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
              ></el-input>
              <span class="title-span">元/组</span>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="editHykDialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="editHykCommit">确 定</el-button>
            </span>
          </el-dialog>
          <!-- <el-dialog
            title="会员规则"
            :visible.sync="hyDialogVisible"
            width="700px"
            :close-on-click-modal="false"
          >
            <div class="dialog-div">
              <span class="title-span">url地址:</span>
              <el-input
                size="small"
                style="width: 500px"
                v-model="hygz"
              ></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="hyDialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="hyCommit">确 定</el-button>
            </span>
          </el-dialog> -->
          <!-- <el-dialog
            title="积分规则"
            :visible.sync="jfDialogVisible"
            width="700px"
            :close-on-click-modal="false"
          >
            <div class="dialog-div">
              <span class="title-span">url地址:</span>
              <el-input
                size="small"
                style="width: 500px"
                v-model="jfgz"
              ></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="jfDialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="jfCommit">确 定</el-button>
            </span>
          </el-dialog> -->
          <el-dialog
            title="规则设置"
            :visible.sync="rulesDialogVisible"
            width="700px"
            :close-on-click-modal="false"
          >
            <div class="dialog-div">
              规则名称:
              <el-input
                clearable
                size="small"
                class="title-select"
                v-model="ruleParams.name"
                placeholder="请输入规则名称"
                @input="inputRuleParams"
              ></el-input>
            </div>
            <el-table :data="rulesList" style="width: 100%">
              <el-table-column
                type="index"
                label="序号"
                align="center"
                width="80"
              >
              </el-table-column>
              <el-table-column prop="name" label="规则名称" align="center">
              </el-table-column>
              <el-table-column prop="url" label="规则地址" align="center">
              </el-table-column>
              <!-- <el-table-column prop="updateBy" label="修改人" align="center">
              </el-table-column> -->
              <!-- <el-table-column
                prop="updateDate"
                label="修改时间"
                align="center"
              >
              </el-table-column> -->
              <el-table-column
                prop="realName"
                label="操作"
                width="150"
                align="center"
              >
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="medium"
                    @click="editRules(scope.row.id)"
                    >编辑</el-button
                  >
                  <el-button
                    type="text"
                    size="medium"
                    @click="deleteRuleById(scope.row.id)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              class="mm-page"
              @size-change="SizeChange"
              @current-change="reluCurrentChange"
              :current-page="reluResult.current"
              :page-size="reluResult.size"
              layout="total,prev, pager, next, sizes"
              :total="reluResult.total"
              :page-sizes="[10, 20, 30, 40, 50]"
            >
            </el-pagination>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="addaRuleAdd"
                >添加规则</el-button
              >
              <el-button @click="rulesDialogVisible = false">关 闭</el-button>
            </span>
          </el-dialog>
          <el-dialog
            :title="ruleTitle"
            :visible.sync="addaRuleDialogVisible"
            width="580px"
            :close-on-click-modal="false"
          >
            <div>
              规则名称:
              <div>
                <el-input
                  size="small"
                  style="width: 200px"
                  v-model="addruleParams.name"
                  :disabled="ruleTitle == '编辑规则'"
                ></el-input>
              </div>
            </div>
            <div style="margin-top: 10px">
              规则地址:
              <div>
                <el-input
                  size="small"
                  style="width: 500px"
                  v-model="addruleParams.url"
                ></el-input>
              </div>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="closeaddaRuleDialogVisible">取 消</el-button>
              <el-button type="primary" @click="addRulesUrl">确 定</el-button>
            </span>
          </el-dialog>
          <el-dialog
            title="会员荣誉"
            :visible.sync="hyryDialogVisible"
            width="580px"
            :close-on-click-modal="false"
          >
            <el-table :data="ryList" style="width: 100%">
              <el-table-column
                type="index"
                label="序号"
                align="center"
                width="80"
              >
              </el-table-column>
              <el-table-column
                prop="honourName"
                label="荣誉名称"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="realName"
                label="操作"
                width="150"
                align="center"
              >
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="medium"
                    @click="deletRy(scope.row.id)"
                    >删除荣誉</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="addhonor">添加荣誉</el-button>
              <el-button @click="hyryDialogVisible = false">关 闭</el-button>
            </span>
          </el-dialog>
          <el-dialog
            title="添加荣誉"
            :visible.sync="addhonorDialogVisible"
            width="580px"
            :close-on-click-modal="false"
          >
            <div>
              荣誉名称 ：
              <el-input
                size="small"
                style="width: 200px"
                v-model="honourName"
                placeholder="请输入新荣誉名称"
              ></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="addhonorDialogVisibleDialogVisible"
                >取 消</el-button
              >
              <el-button type="primary" @click="addhonour">确 定</el-button>
            </span>
          </el-dialog>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {
  updateMembersCardLevel,
  getMembersLevelPage,
  addMembersCardLevel,
  getMembersLevelById,
  // getRuleUrlByType,
  // updateRulesUrl,
  addRulesUrl,
  getRulesPage,
  updateRulesUrlSecond,
  getRuleById,
  deleteRuleById,
  addHonour,
  getHonourList,
  deleteHonour,
  getSysConfig,
  updateSysCOnfig,
} from "../../api/BusinessManagement.js";
import { globelurl, posturl } from "../../api/axios.js";

export default {
  name: "MembershipLevel",
  data() {
    return {
      activeName: "four",
      upLoadUrl: posturl,
      headers: { "X-Access-Token": sessionStorage.token },
      hykParams: {
        cardName: "",
        pageNo: 1,
        pageSize: 10,
      },
      hykResult: {},
      hykList: [],
      LevelSelectList: [
        {
          key: 1,
          value: "一级",
        },
        {
          key: 2,
          value: "二级",
        },
        {
          key: 3,
          value: "三级",
        },
        {
          key: 4,
          value: "四级",
        },
        {
          key: 5,
          value: "五级",
        },
        {
          key: 6,
          value: "六级",
        },
        {
          key: 7,
          value: "七级",
        },
        {
          key: 8,
          value: "八级",
        },
        {
          key: 9,
          value: "九级",
        },
        {
          key: 10,
          value: "十级",
        },
        {
          key: 11,
          value: "十一级",
        },
        {
          key: 12,
          value: "十二级",
        },
        {
          key: 13,
          value: "十三级",
        },
        {
          key: 14,
          value: "十四级",
        },
        {
          key: 15,
          value: "十五级",
        },
        {
          key: 16,
          value: "十六级",
        },
        {
          key: 17,
          value: "十七级",
        },
        {
          key: 18,
          value: "十八级",
        },
        {
          key: 19,
          value: "十九级",
        },
        {
          key: 20,
          value: "二十级",
        },
      ],
      creatCard: {
        arrowVolume: "",
        cardName: "",
        electronicCard: "",
        electronicCardDays: "",
        storedValue: "",
        equitiesList: [
          {
            id: "",
            level: "",
            levelId: "",
            name: "",
            pointEnd: "",
            pointStart: "",
            price: "",
          },
        ],
        followPrice: "",
        id: "",
        level: "",
        upgradePrice: "",
      },
      editCard: {
        arrowVolume: "",
        arrowVolumeDays: "",
        cardName: "",
        electronicCard: "",
        electronicCardDays: "",
        storedValue: "",
        equitiesList: [
          {
            id: "",
            level: "",
            levelId: "",
            name: "",
            pointEnd: "",
            pointStart: "",
            price: "",
          },
        ],
        followPrice: "",
        id: "",
        level: "",
        upgradePrice: "",
      },
      creatHykDialogVisible: false,
      editHykDialogVisible: false,
      // hyDialogVisible: false,
      // jfDialogVisible: false,
      // hygz: "",
      // hygzId: "",
      // jfgz: "",
      // jfgzId: "",
      rulesDialogVisible: false,
      addaRuleDialogVisible: false,
      ruleParams: {
        name: "",
        pageNo: 1,
        pageSize: 10,
      },
      rulesList: [],
      reluResult: {},
      addruleParams: {
        name: "",
        url: "",
      },
      ruleId: "",
      ruleTitle: "",
      hyryDialogVisible: false,
      honourName: "",
      ryList: [],
      addhonorDialogVisible: false,
      configValue: "",
    };
  },
  mounted() {
    this.getMembersLevelPage(this.hykParams);
    this.getSysConfig();
  },
  methods: {
    //tab栏切换
    handleClick(tab, event) {
      if (tab.label == "门店管理") {
        this.$router.push("/BusinessManagement/StoreManagement");
      } else if (tab.label == "账号管理") {
        this.$router.push("/BusinessManagement/NumberManagement");
      }
      // else if (tab.label == '角色权限') {
      //   this.$router.push('/BusinessManagement/RolePermissions');
      // }
      else if (tab.label == "会员等级") {
      }
    },
    //查询会员卡等级
    getMembersLevelPage(params) {
      getMembersLevelPage(params).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
          } else {
            this.hykResult = res.data.result;
            this.hykList = res.data.result.records;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    getSysConfig() {
      getSysConfig().then((res) => {
        this.configValue = res.data.result.configValue;
      });
    },
    //添加新建标签
    addCreatLabel() {
      if (this.creatCard.equitiesList.length < 5) {
        this.creatCard.equitiesList.push({
          id: "",
          level: "",
          levelId: "",
          name: "",
          pointEnd: "",
          pointStart: "",
          price: "",
        });
      } else {
        return this.$message.error("最多添加五条");
      }
    },
    // 删除新建标签
    delCreatLabel(i) {
      this.creatCard.equitiesList.splice(i, 1);
    },
    //添加删除标签
    addEditLabel() {
      if (this.editCard.equitiesList.length < 5) {
        this.editCard.equitiesList.push({
          id: "",
          level: "",
          levelId: "",
          name: "",
          pointEnd: "",
          pointStart: "",
          price: "",
        });
      } else {
        return this.$message.error("最多添加五条");
      }
    },
    //删除编辑标签
    delEditLabel(i) {
      this.editCard.equitiesList.splice(i, 1);
    },
    //会员卡管理页码跳转
    hykSizeChange(newSize) {
      this.hykParams.pageSize = newSize;
      this.getMembersLevelPage(this.hykParams);
    },
    //会员卡管理页码跳转
    hykCurrentChange(newPage) {
      this.hykParams.pageNo = newPage;
      this.getMembersLevelPage(this.hykParams);
    },
    //会员卡名称检索输入框改变
    cardNameChange() {
      this.hykParams.pageNo = 1;
      this.getMembersLevelPage(this.hykParams);
    },
    //新建会员卡提交
    createHykCommit() {
      if (this.creatCard.cardName === "") {
        this.$message.error("请输入会员等级名称");
      } else if (this.creatCard.level === "") {
        this.$message.error("请选择会员等级");
      } else if (this.creatCard.upgradePrice === "") {
        this.$message.error("请输入办理金额");
      } else if (this.creatCard.arrowVolume === "") {
        this.$message.error("请输入赠送箭票数");
      } else if (this.creatCard.electronicCard === "") {
        this.$message.error("请输入电子卡张数");
      } else if (this.creatCard.electronicCardDays === "") {
        this.$message.error("请输入电子卡使用期限");
      } else if (this.creatCard.followPrice === "") {
        0;
        this.$message.error("请输入随行人员价格");
      } else {
        addMembersCardLevel(this.creatCard).then((res) => {
          if (res.status === 200 && res.data.success) {
            if (res.data.result.total === 0) {
              this.$Notice.open({
                title: "查无数据",
              });
            } else {
              this.$message.success("新建账号成功");
              this.creatHykDialogVisible = false;
              this.getMembersLevelPage(this.hykParams);
              this.creatCard = {
                arrowVolume: "",
                cardName: "",
                electronicCard: "",
                electronicCardDays: "",
                storedValue: "",
                equitiesList: [
                  {
                    id: "",
                    level: "",
                    levelId: "",
                    name: "",
                    pointEnd: "",
                    pointStart: "",
                    price: "",
                  },
                ],
                followPrice: "",
                id: "",
                level: "",
                upgradePrice: "",
              };
            }
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
    },
    //获取账号信息
    hykEdit(val) {
      getMembersLevelById({ id: val }).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
          } else {
            this.editHykDialogVisible = true;
            this.editCard.arrowVolume = res.data.result.arrowVolume;
            this.editCard.arrowVolumeDays = res.data.result.arrowVolumeDays;
            this.editCard.cardName = res.data.result.cardName;
            this.editCard.followPrice = res.data.result.followPrice;
            this.editCard.upgradePrice = res.data.result.upgradePrice;
            this.editCard.level = res.data.result.level;
            this.editCard.electronicCard = res.data.result.electronicCard;
            this.editCard.electronicCardDays =
              res.data.result.electronicCardDays;
            this.editCard.storedValue = res.data.result.storedValue;
            this.editCard.id = res.data.result.id;
            this.editCard.equitiesList = res.data.result.equitiesList;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //编辑账号提交
    editHykCommit() {
      if (this.editCard.cardName === "") {
        this.$message.error("请输入会员等级名称");
      } else if (this.editCard.level === "") {
        this.$message.error("请选择会员等级");
      } else if (this.editCard.upgradePrice === "") {
        this.$message.error("请输入办理金额");
      } else if (this.editCard.arrowVolume === "") {
        this.$message.error("请输入赠送箭票数");
      } else if (!this.editCard.arrowVolumeDays) {
        this.$message.error("请输入赠送箭票数使用期限");
      } else if (this.editCard.electronicCard === "") {
        this.$message.error("请输入电子卡张数");
      } else if (this.editCard.electronicCardDays === "") {
        this.$message.error("请输入电子卡使用期限");
      } else if (this.editCard.followPrice === "") {
        this.$message.error("请输入随行人员价格");
      } else {
        updateMembersCardLevel(this.editCard).then((res) => {
          if (res.status === 200 && res.data.success) {
            if (res.data.result.total === 0) {
              this.$Notice.open({
                title: "查无数据",
              });
            } else {
              this.$message.success("编辑账号成功");
              this.editHykDialogVisible = false;
              this.getMembersLevelPage(this.hykParams);
            }
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
    },
    //会员规则获取
    // hyChange() {
    //   getRuleUrlByType({ type: 0 }).then((res) => {
    //     if (res.status === 200 && res.data.success) {
    //       if (res.data.result.total === 0) {
    //         this.$Notice.open({
    //           title: "查无数据",
    //         });
    //       } else {
    //         this.hyDialogVisible = true;
    //         this.hygz = res.data.result.url;
    //         this.hygzId = res.data.result.id;
    //       }
    //     } else {
    //       this.$message.error(res.data.message);
    //     }
    //   });
    // },
    //积分规则获取
    // jfChange() {
    //   getRuleUrlByType({ type: 1 }).then((res) => {
    //     if (res.status === 200 && res.data.success) {
    //       if (res.data.result.total === 0) {
    //         this.$Notice.open({
    //           title: "查无数据",
    //         });
    //       } else {
    //         this.jfDialogVisible = true;
    //         this.jfgz = res.data.result.url;
    //         this.jfgzId = res.data.result.id;
    //       }
    //     } else {
    //       this.$message.error(res.data.message);
    //     }
    //   });
    // },
    // 规则设置
    ruleButton() {
      this.rulesDialogVisible = true;
      this.getRulesPage();
    },
    // 规则列表
    getRulesPage() {
      getRulesPage(this.ruleParams).then((res) => {
        if (res.status === 200 && res.data.success) {
          this.rulesList = res.data.result.records;
          this.reluResult = res.data.result;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    SizeChange(newSize) {
      this.ruleParams.pageSize = newSize;
      this.getRulesPage();
    },
    reluCurrentChange(newPage) {
      this.ruleParams.pageNo = newPage;
      this.getRulesPage();
    },
    closeaddaRuleDialogVisible() {
      this.addaRuleDialogVisible = false;
      this.addruleParams.name = "";
      this.addruleParams.url = "";
    },
    addaRuleAdd() {
      this.addaRuleDialogVisible = true;
      this.ruleTitle = "添加规则";
    },
    addhonor() {
      this.addhonorDialogVisible = true;
    },
    addhonorDialogVisibleDialogVisible() {
      this.addhonorDialogVisible = false;
      this.honourName = "";
    },
    inputRuleParams() {
      this.ruleParams.pageNo = 1;
      this.getRulesPage();
    },
    // 添加规则
    addRulesUrl() {
      if (this.addruleParams.name === "") {
        this.$message.error("请输入规则名称");
      } else if (this.addruleParams.url === "") {
        this.$message.error("请輸入规则地址");
      } else {
        if (this.ruleTitle == "添加规则") {
          addRulesUrl({
            name: this.addruleParams.name,
            url: this.addruleParams.url,
          }).then((res) => {
            if (res.status === 200 && res.data.success) {
              this.closeaddaRuleDialogVisible();
              this.getRulesPage();
              this.$message.success("规则添加成功");
            } else {
              this.$message.error(res.data.message);
            }
          });
        } else {
          updateRulesUrlSecond({
            url: this.addruleParams.url,
            id: this.ruleId,
          }).then((res) => {
            if (res.status === 200 && res.data.success) {
              this.addaRuleDialogVisible = false;
              this.getRulesPage();
              this.$message.success("规则修改成功");
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      }
    },
    // 编辑规则
    editRules(ruleId) {
      this.ruleTitle = "编辑规则";
      this.addaRuleDialogVisible = true;
      getRuleById({ ruleId }).then((res) => {
        if (res.status === 200 && res.data.success) {
          this.addruleParams.name = res.data.result.name;
          this.addruleParams.url = res.data.result.url;
          this.ruleId = res.data.result.id;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 删除规则
    deleteRuleById(ruleId) {
      deleteRuleById({ id: ruleId }).then((res) => {
        if (res.status === 200 && res.data.success) {
          this.$message.success("规则删除成功");
          this.getRulesPage();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //会员规则修改
    // hyCommit() {
    //   updateRulesUrl({ type: 0, url: this.hygz, id: this.hygzId }).then(
    //     (res) => {
    //       if (res.status === 200 && res.data.success) {
    //         if (res.data.result.total === 0) {
    //           this.$Notice.open({
    //             title: "查无数据",
    //           });
    //         } else {
    //           this.hyDialogVisible = false;
    //           this.$message.success("会员规则发布成功");
    //         }
    //       } else {
    //         this.$message.error(res.data.message);
    //       }
    //     }
    //   );
    // },
    //积分规则修改
    // jfCommit() {
    //   updateRulesUrl({ type: 1, url: this.jfgz, id: this.jfgzId }).then(
    //     (res) => {
    //       if (res.status === 200 && res.data.success) {
    //         if (res.data.result.total === 0) {
    //           this.$Notice.open({
    //             title: "查无数据",
    //           });
    //         } else {
    //           this.jfDialogVisible = false;
    //           this.$message.success("积分规则发布成功");
    //         }
    //       } else {
    //         this.$message.error(res.data.message);
    //       }
    //     }
    //   );
    // },
    //会员荣誉
    honourManage() {
      this.hyryDialogVisible = true;
      this.getHonourList();
    },
    //荣誉列表
    getHonourList() {
      getHonourList().then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.length === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
          } else {
            this.ryList = res.data.result;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //删除荣誉
    deletRy(ryId) {
      deleteHonour({ id: ryId }).then((res) => {
        if (res.status === 200 && res.data.success) {
          this.$message.success("会员荣誉删除成功");
          this.getHonourList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //添加荣誉
    addhonour() {
      if (this.honourName == "") {
        this.$message.error("请输入会员荣誉");
      } else {
        addHonour({ honourName: this.honourName }).then((res) => {
          if (res.status === 200 && res.data.success) {
            this.getHonourList();
            this.addhonorDialogVisibleDialogVisible();
            this.$message.success("会员荣誉添加成功");
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
    },
    switchChange(value) {
      updateSysCOnfig({ configValue: value }).then((res) => {
        if (res.status==200) {
          this.$message.success("修改成功");
        }
      });
    },
  },
};
</script>

<style scoped>
.title-span {
  font-size: 16px;
}

.title_div {
  margin: 20px 30px;
}

.title-select {
  margin: 0 20px;
  width: 200px;
}

.title-date1 {
  margin-left: 20px;
  width: 180px;
}

.title-date2 {
  width: 180px;
}

.creat-button {
  margin: 20px;
}

.mm-tb {
  width: 90%;
  margin-left: 50px;
}

.mm-page {
  margin: 30px 60px;
}

.dialog-div {
  margin: 20px 50px;
}

.orderMain {
  padding: 30px;
}
</style>

